import { IntergrationInstructionInput } from '../../../../lib/api/account-linking/types';

export interface StepInputOption {
  value: string;
  text: string;
}

// Flatten an input's option groups into a single list of selectable options.
export function getInputOptions(input: IntergrationInstructionInput): StepInputOption[] {
  const output: StepInputOption[] = [];
  input.optionGroups?.forEach((group) => {
    group?.options?.forEach((o) => {
      if (group.keyIsValue) {
        output.push({ value: o.key, text: o.value });
      } else {
        output.push({ value: o.value, text: o.key });
      }
    });
  });

  return output;
}

// The value an input should default to when there is no API-provided value.
// Dropdowns default to their first option so the visible selection matches form
// state. Other input types (dates, checkboxes, free text) start empty.
export function getDefaultInputValue(input: IntergrationInstructionInput): string | undefined {
  if (input.type === 'MultipleChoice') {
    const options = getInputOptions(input);
    return options.length > 0 ? options[0].value : undefined;
  }

  return undefined;
}
